"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import Image from "@/components/common/image/image";
import Skeleton from "@/components/common/skeleton/Skeleton";
import { useStatistics } from "@/hooks/useStatistics";
import { buildHomeAds } from "../../utilities/statistics";
enum AdState {
  FADE_IN,
  FADE_OUT,
  HIDDEN,
  VISIBLE,
}
const HomeAds = () => {
  const $ = _c(14);
  const {
    statistics,
    isLoading
  } = useStatistics();
  const ads = statistics ? buildHomeAds(statistics) : [];
  const [selectedAd, setSelectedAd] = useState(0);
  const [adState, setAdState] = useState(AdState.VISIBLE);
  const timeoutRef = useRef(null);
  const handleTransitionEnd = () => {
    if (adState === AdState.FADE_OUT) {
      const adCount = ads.length || 0;
      setSelectedAd(prev => adCount ? (prev + 1) % adCount : 0);
      setAdState(AdState.HIDDEN);
    } else {
      if (adState === AdState.FADE_IN) {
        setAdState(AdState.VISIBLE);
        timeoutRef.current = setTimeout(() => {
          setAdState(AdState.FADE_OUT);
        }, 2000);
      }
    }
  };
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setAdState(AdState.VISIBLE);
      timeoutRef.current = setTimeout(() => {
        setAdState(AdState.FADE_OUT);
      }, 2000);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const resetTimer = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      window.addEventListener("resize", resetTimer);
      return () => {
        window.removeEventListener("resize", resetTimer);
      };
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== adState) {
    t3 = () => {
      if (adState === AdState.HIDDEN) {
        setAdState(AdState.FADE_IN);
      }
    };
    $[3] = adState;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== adState || $[6] !== selectedAd) {
    t4 = [adState, selectedAd];
    $[5] = adState;
    $[6] = selectedAd;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setAdState(AdState.VISIBLE);
      timeoutRef.current = setTimeout(() => {
        setAdState(AdState.FADE_OUT);
      }, 2000);
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useEffect(t5, [ads.length]);
  if (isLoading) {
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Skeleton className="h-[42px] w-[270px] rounded-lg" />;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    return t6;
  }
  if (ads.length === 0) {
    return null;
  }
  const ad = ads[selectedAd];
  const t6 = `flex h-[42px] w-fit items-center gap-3 rounded-lg border-[1px] border-[#087F00] bg-[#2196530D] px-3 text-sm font-semibold leading-none text-[#087F00] transition-opacity duration-1000 ${[AdState.VISIBLE, AdState.FADE_IN].includes(adState) ? "opacity-100" : "opacity-0"}`;
  const t7 = ad.list.map(_temp);
  let t8;
  if ($[10] !== handleTransitionEnd || $[11] !== t6 || $[12] !== t7) {
    t8 = <div className={t6} onTransitionEnd={handleTransitionEnd}>{t7}</div>;
    $[10] = handleTransitionEnd;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
export default HomeAds;
function _temp(entry, index) {
  if (entry.type === "text") {
    return <span key={index}>{entry.content}</span>;
  }
  if (entry.type === "icon") {
    return <Image key={index} className="mx-[-6px]" src={entry.content} alt="icon" width={16} height={16} />;
  }
  return <Image key={index} src={entry.content} alt="icon" width={24} height={24} />;
}